const tabsFn = () => {
  const select = $('.catalog__select select');
  const nav = $('.catalog__nav');
  const tabs = $('.catalog-tabs');

  nav.on('click', 'a', function () {
    const rel = $(this).attr('rel');

    nav.find('a').removeClass('active');
    $(this).addClass('active');

    tabs.find('.fade').removeClass('active in');
    tabs.find(`[rel="${rel}"]`).addClass('active in');

    select.val(rel);
  });

  select.on('change', function () {
    const current = $(this).val();

    nav.find('a').removeClass('active');
    nav.find(`[rel="${current}"]`).trigger('click');
  });
};

export default tabsFn;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/common/tabs.js